import React, { useState } from "react";
import CustomBtn from "components/fragments/CustomBtn";
import { useNavigate } from "react-router-dom";
import LogoutConfirmModal from "../components/modals/LogoutConfirmModal";
import { useDispatch } from "react-redux";
import { authHandler } from "../redux/handlers";
import socketService from "../services/socketService";

export default function ChangeBusinessSlug() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [showLogoutModal, setShowLogoutModal] = useState(false);
  const getSlug = () => {
    const urlParts = window.location.href.split("/").filter(Boolean);
    return urlParts[2];
  };

  const handleLogoutClick = () => {
    setShowLogoutModal(true);
  };

  const handleCancelLogout = () => {
    setShowLogoutModal(false);
  };

  const handleConfirmLogout = async () => {
    setShowLogoutModal(true);
    localStorage.removeItem("email");
    localStorage.removeItem("branchId");
    localStorage.removeItem("accessToken");
    localStorage.removeItem("refreshToken");
    localStorage.removeItem("branchKitchenId");
    localStorage.removeItem("branchPOSId");
    socketService.disconnect();
    await dispatch(authHandler.logout(getSlug()));
    navigate(`/${getSlug()}/login`, { replace: true });
  };

  return (
    <div className="d-flex flex-column align-items-center justify-content-center min-vh-100 bg-light">
      <div className="text-center py-5 px-28 bg-white rounded shadow">
        <h2 className="h3 mb-4"> คุณต้องการใช้ธุรกิจชื่อ {getSlug()}</h2>
        <CustomBtn
          onClick={handleLogoutClick}
          className={`leading-[0.8] !bg-[#2DC76D] w-full min-w-[min(10.25vw,105px)] text-18 !text-[#FFF] font-[600] !min-h-[50px] rounded-[min(0.78vw,8px)]`}
          btntxt={"เข้าสู่ระบบ"}
        />
      </div>
      <LogoutConfirmModal isOpen={showLogoutModal} onClose={handleCancelLogout} onConfirm={handleConfirmLogout} />
    </div>
  );
}
